import React from "react";
import phone from "../../../assets/images/phone.png";
import fitness from "../../../assets/images/fitness.jpeg";
import tutor from "../../../assets/images/tutor.jpeg";
import { Link } from "react-router-dom";

const MyProjects = () => {
  
  return (
    <div className="mb-20" id="projects">
      <div className="text-center mb-8">
        <h2 className="text-3xl mb-5">My Projects</h2>
      </div>
      <div className="grid gap-9 mt-8 mb-10 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 px-10">

        <div className="card card-compact w-96 bg-neutral shadow-xl">
          <figure>
            <img src={phone} className="w-full" alt="phone" />
          </figure>
          <div className="card-body">
            <h2 className="card-title">Phone Resale</h2>
            <p>
              Phone Resale is a buy and sell website. Where you can sell your
              old phone.
            </p>
            <div className="card-actions justify-center">
              <Link to='/project1' className="btn btn-primary">Details </Link>
            </div>
          </div>
        </div>
        <div className="card card-compact w-96 bg-neutral shadow-xl">
          <figure>
            <img src={fitness} className="w-full" alt="fitness" />
          </figure>
          <div className="card-body">
            <h2 className="card-title">Health Coach</h2>
            <p>
              Health Coach is a individual fitness training program website. 
            </p>
            <div className="card-actions justify-center">
              <Link to='/project2' className="btn btn-primary">Details </Link>
            </div>
          </div>
        </div>
        <div className="card card-compact w-96 bg-neutral shadow-xl">
          <figure>
            <img src={tutor} className="w-full" alt="tutor" />
          </figure>
          <div className="card-body">
            <h2 className="card-title">Tutor Academy</h2>
            <p>
            Tutor Academy is a online based learning website. Where you can know about web technology. 
            </p>
            <div className="card-actions justify-center">
              <Link to='/project3' className="btn btn-primary">Details </Link>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  );
};

export default MyProjects;
